import { SettingsForm } from './settings';
export const organizations = {
    get settings() {
        return new SettingsForm();
    },
};
